export default "__VITE_PUBLIC_ASSET__9f0aa942__"